
import { supabase } from '@/integrations/supabase/client';
import { GamePlan } from '@/types/gamePlanner';

export const getGamePlans = async (): Promise<GamePlan[]> => {
  const { data: { user } } = await supabase.auth.getUser();
  
  if (!user) {
    throw new Error('User not authenticated');
  }

  const { data, error } = await supabase
    .from('game_plans')
    .select('*')
    .eq('user_id', user.id)
    .order('updated_at', { ascending: false });

  if (error) {
    console.error('Error fetching game plans:', error);
    throw error;
  }

  return data.map((plan: { id: string; name: string; description: string; flow_data: unknown; thumbnail: string; user_id: string; is_template: boolean; is_public: boolean; created_at: string; updated_at: string }) => ({
    id: plan.id,
    name: plan.name,
    description: plan.description,
    flow_data: plan.flow_data,
    thumbnail: plan.thumbnail,
    user_id: plan.user_id,
    is_template: plan.is_template,
    is_public: plan.is_public,
    created_at: plan.created_at,
    updated_at: plan.updated_at,
    last_updated: new Date(plan.updated_at).toLocaleDateString()
  }));
};

export const getSharedGamePlan = async (shareId: string): Promise<GamePlan | null> => {
  try {
    const { data, error } = await supabase
      .from('shared_game_plans')
      .select('*')
      .eq('share_id', shareId)
      .single();

    if (error) {
      console.error('Error fetching shared game plan:', error);
      return null;
    }

    // Map shared game plan data to GamePlan interface
    return {
      id: data.id,
      name: data.name,
      description: data.description,
      flow_data: data.flow_data,
      thumbnail: data.thumbnail,
      user_id: data.creator_id || '',
      is_template: false,
      is_public: true,
      created_at: data.created_at,
      updated_at: data.updated_at,
      last_updated: new Date(data.updated_at || data.created_at).toLocaleDateString()
    };
  } catch (error) {
    console.error('Exception fetching shared game plan:', error);
    return null;
  }
};
